import { entity, type EntityType } from "@/admin/entity.ts";
import { WModalForm, type WModalFormProps } from "@/components/forms/WModalForm.tsx";
import { mustGetProperty } from "@warrenio/utils/collections/getOwnProperty";
import type { FieldValues } from "react-hook-form";

interface FormParams {
    entityType: EntityType;
    isUpdate: boolean;
}

function formProps({ entityType, isUpdate }: FormParams) {
    const e = mustGetProperty(entity, entityType);
    return {
        label: isUpdate ? "Edit" : "Add",
        title: isUpdate ? e.editLabel : e.addLabel,
    };
}

export interface WAdminModalCrudFormProps<T extends FieldValues>
    extends FormParams, Omit<WModalFormProps<T>, "title" | "label"> {}

export function WAdminModalCrudForm<T extends FieldValues>({
    children,
    entityType,
    isUpdate,
    ...props
}: WAdminModalCrudFormProps<T>) {
    const entityProps = formProps({ entityType, isUpdate });

    return (
        <WModalForm {...entityProps} {...props}>
            {children}
        </WModalForm>
    );
}
